exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.summary_title_description {\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.summary__quantity__unavailable {\n  position: relative;\n  top: 0;\n  margin-top: 0;\n  float: right;\n  padding: 10px;\n  border-radius: 5px;\n  background: #efefef;\n}\n.summary-mobile {\n.summary__title h1 {\n    font-size: 16px;\n}\n.summary__price {\np {\n      margin-bottom: 0px;\n}\n}\n.price_box span {\n    font-size: 35px;\n    font-weight: bold;\n}\n.summary__description {\n    margin-top: 30px;\n    color: #696969;\n}\n}\n", ""]);

// exports
